import { Markdown } from 'components';
import { FLOW_TYPE } from 'consts/flows';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';
import { RiskqTextRRSU } from './RiskqTextRRSU';

type RiskqTextProps = Readonly<{
	isLastPage: boolean;
	testType: string;
	flowType: string;
}>;

export function RiskqText(props: RiskqTextProps) {
	const { flowType, isLastPage, testType } = props;
	const { t } = useContext(AppContext);

	if (FLOW_TYPE.RR_SU === flowType) {
		return <RiskqTextRRSU />;
	}

	const suffix = isLastPage ? 'derivatives_text' : 'page_1_text';

	return (
		<div className="arionui mb-5">
			<Markdown>{t(`${testType}_${suffix}`, 'testRisk')}</Markdown>
		</div>
	);
}
